import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { ChangeEvent, MouseEvent, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { CreatePointStakeType } from '@/types';
import { createSeason } from '@/api/point/create';
import { toast } from 'react-toastify';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';
import { isValid, nowSubtractToISOString } from '@/lib/dayjs';
import { SUCCESS } from '@/lib/common/name-space';

export default function RegisterStake({
  settingId,
  onSuccess,
  refresh,
}: {
  settingId: string;
  onSuccess: () => void;
  refresh: number;
}) {
  const defaultItem: CreatePointStakeType = {
    settingId: settingId,
    title: '',
    startDt: '',
    endDt: '',
    rewardDt: '',
    interestRate: '',
    usdt: '',
    requireAmount: '',
  };
  const [item, setItem] = useState<CreatePointStakeType>(defaultItem);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setItem(defaultItem);
      // await readSettingAcumulatedList();
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    setItem((prev: CreatePointStakeType) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!item.title) {
      toast.error('제목을 넣어 주세요.');
      return;
    }
    if (!item.interestRate) {
      toast.error('%에 맞게 입력하세요.');
    }
    if (!isValid(item.startDt) || !isValid(item.endDt)) {
      toast.error('날짜 형식에 맞게 작성해 주세요: YYYY-MM-DD HH:mm:ss');
      return;
    }

    setIsLoading(true);
    try {
      const re = await createSeason(item);
      if (re.status !== SUCCESS) {
        toast.error(re.message);
        setIsLoading(false);
        return;
      }
      await sleep(1000);
      toast.success('성공');
      setIsLoading(false);
      onSuccess();
    } catch (e) {
      toast.error('실패');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6">스테이킹 풀 세팅(에셋 스테이킹 풀 생성 후 추가 생성해야 합니다. 연동 X)</Typography>
      <Box p={1} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Title</InputLabel>
            <OutlinedInput value={item.title} label="title" name="title" onChange={handleChangeValue} />
          </FormControl>
        </Grid>

        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>이자 (%)</InputLabel>
            <OutlinedInput
              value={item.interestRate}
              label="interestRate"
              name="interestRate"
              onChange={handleChangeValue}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={2} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>시작날짜</InputLabel>
            <OutlinedInput
              type="string"
              value={item.startDt}
              label="startDt"
              name="startDt"
              onChange={handleChangeValue}
            />
            <FormHelperText>
              ※ kst 입력해야 utc로 저장됨 / YYYY-MM-DD HH:mm:ss / utc: {nowSubtractToISOString(item.startDt)}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>종료 날짜</InputLabel>
            <OutlinedInput type="string" value={item.endDt} label="endDt" name="endDt" onChange={handleChangeValue} />
            <FormHelperText>
              ※ kst 입력해야 utc로 저장됨 / YYYY-MM-DD HH:mm:ss / utc: {nowSubtractToISOString(item.endDt)}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={2} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>리워드 지급일</InputLabel>
            <OutlinedInput
              type="string"
              value={item.rewardDt}
              label="rewardDt"
              name="rewardDt"
              onChange={handleChangeValue}
            />
          </FormControl>
        </Grid>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>usdt</InputLabel>
            <OutlinedInput type="string" value={item.usdt} label="usdt" name="usdt" onChange={handleChangeValue} />
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={5} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>목표 포인트</InputLabel>
            <OutlinedInput
              type="string"
              value={item.requireAmount}
              label="requireAmount"
              name="requireAmount"
              onChange={handleChangeValue}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={5} />
      <Button fullWidth variant="contained" onClick={onSubmit}>
        생성
      </Button>
      <Loading isLoading={isLoading} />
    </>
  );
}
